module.exports = window["core-js/modules/web.dom-collections.iterator.js"];